import { Delete } from '@components/atoms';
import { Discount } from '@components/atoms/icons/discount';
import { Button } from '@components/molecules';
import type { CartItemProps } from '../types';

type CartItemActionsProps = Pick<
	CartItemProps,
	'item' | 'onDeleteItem' | 'isLoading' | 'disableDiscount' | 'onDiscountItem' | 'disableDelete'
>;

export const CartItemActions = ({
	item,
	onDeleteItem,
	isLoading,
	disableDiscount,
	onDiscountItem,
	disableDelete,
}: CartItemActionsProps) => {
	const isDiscountDisabled = disableDiscount?.(item);
	return (
		<div className="flex flex-row gap-2" data-testid="cart-item-actions">
			{!isDiscountDisabled && (
				<Button
					aria-label="Discount item"
					variant="tertiaryNew"
					iconButton
					onClick={() => onDiscountItem?.(item)}
					disabled={isLoading}
				>
					<Discount />
				</Button>
			)}
			{!disableDelete && (
				<Button
					aria-label="Delete item"
					variant="tertiaryNew"
					iconButton
					onClick={() => onDeleteItem?.(item)}
					disabled={isLoading}
				>
					<Delete />
				</Button>
			)}
		</div>
	);
};
